import { Component, OnInit } from '@angular/core';
import { FilteredListConfig, FilteredListItem, Badge } from '@appcatalyst/ng-cms-core-lib';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Observable, Subject } from "rxjs";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-insurances',
  templateUrl: './insurances.component.html',
  styleUrls: ['./insurances.component.scss']
})
export class InsurancesComponent implements OnInit {
  insurances$: Observable<any>
  private insurances: any[]
  params: any
  
  constructor(
    private config: FilteredListConfig,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.params = {...params}
    })
    this.route.data.subscribe((data: {insurances: any}) => {
      this.insurances$ = data.insurances
      this.insurances = data.insurances
      this.config.listItems = this.insurances.map(insurance => {
        return {
          _id: insurance.id,
          title: insurance.name,
        }
      });
      this.config.count = this.insurances.length
      this.config.page = 1
      this.config.limit = this.insurances.length
      this.config.emitChanges()
    })
    this.config.title = 'Insurances'
  }
}
